import { FETCH_STATUS } from '../actions/authActions';

export type Status =
  | 'loading'
  | 'anonymous'
  | 'authenticating'
  | 'authenticated';

export type AuthReducerActionType = {
  type: string;
  payload: Status;
};

const authReducer = (state = 'anonymous', action: AuthReducerActionType) => {
  switch (action.type) {
    case FETCH_STATUS:
      return action.payload || 'authenticating';
    default:
      return state;
  }
};

export default authReducer;
